export default __webpack_public_path__ + "static/media/desktop_menu_arrow_hover.0862bc99.svg";